import { Button, Card, Divider, Flex, Radio, Typography } from "antd"
import VSpace from "../../common/VSpace"
import RadioButton from "../../common/RadioButton"
import { InvoiceOption } from "./payInvoiceModel"

type Props = {
  selectedOption: InvoiceOption
  onOptionChange: (option: InvoiceOption) => void
  allowPaymentMethodOnFile: boolean
  paymentPageUrl: string
  documentLabel?: string
}

const InvoiceOptionsCard = ({
  selectedOption,
  onOptionChange,
  allowPaymentMethodOnFile,
  paymentPageUrl,
  documentLabel = 'Invoice'
}: Props) => {
  return <Card
    title={<div style={{ margin: "16px 0" }}>
      {documentLabel} Options
      <br/>
      <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>
        Choose whether to send the {documentLabel.toLowerCase()} or pay it now if a payment method is saved on file.
      </Typography.Text>
    </div>}
  >
    <Radio.Group value={selectedOption} onChange={x => onOptionChange(x.target.value)} style={{ width: '100%' }}>
      <Flex gap={8}>

      {allowPaymentMethodOnFile && <div style={{width: '100%'}}><RadioButton
        value={"methodOnFile"}
        checked={selectedOption === 'methodOnFile'}
        onBorderClick={() => onOptionChange("methodOnFile")}
      >Pay Now with Payment Method on File</RadioButton></div>}

      <div style={{width: '100%', marginBottom: '8px'}}>
        <RadioButton
          value={"markPaidManually"}
          checked={selectedOption === 'markPaidManually'}
          onBorderClick={() => onOptionChange("markPaidManually")}
        >Mark {documentLabel} as Paid</RadioButton>
      </div>
      </Flex>
    </Radio.Group>
    <Divider plain>Or</Divider>
    <VSpace>
      <div style={{textAlign: 'center'}}>Need to process payment over the phone or add a new payment method?</div>
      <Button block size="large" onClick={() => window.open(paymentPageUrl, '_blank')}>Go to Checkout</Button>
    </VSpace>
  </Card>
}

export default InvoiceOptionsCard
